module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('h3', [_vm._v("Start New Game")]), _vm._v(" "), (_vm.step === 1) ? _c('div', [_c('label', [_vm._v("Select Number of Players:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.numOfPlayers),
      expression: "numOfPlayers"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.numOfPlayers = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("8")])]), _c('br'), _c('br'), _vm._v(" "), _c('label', [_vm._v("Use tiebreaking:")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_c('label', {
    attrs: {
      "for": "TBtrue"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tieBreaker),
      expression: "tieBreaker"
    }],
    attrs: {
      "type": "radio",
      "id": "TBtrue"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.tieBreaker, true)
    },
    on: {
      "change": function($event) {
        _vm.tieBreaker = true
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "TBfalse"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tieBreaker),
      expression: "tieBreaker"
    }],
    attrs: {
      "type": "radio",
      "id": "TBfalse"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.tieBreaker, false)
    },
    on: {
      "change": function($event) {
        _vm.tieBreaker = false
      }
    }
  })]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showTiebreaker
    }
  }, [_vm._v(_vm._s(_vm.tiebreakerShown ? "hide details" : "show details"))]), _c('br'), _vm._v(" "), (_vm.tiebreakerShown) ? _c('p', [_vm._v("\n      Tie breaker will help prevent any advantage in case of a tied dice roll."), _c('br'), _vm._v("\n      If set to \"No,\" the defense will always win a tie. This means if offense and defense both roll two of the same number, offense will lose 2 troops. "), _c('br'), _vm._v("\n      If set to \"Yes,\" the above scenario will result in each player losing one troop, and in the case of one tie, the defense will lose every other time and the offense will lose every other time.\n    ")]) : _c('br'), _vm._v(" "), _c('label', [_vm._v("Allow card stockpiling:")]), _vm._v(" "), _c('span', {
    staticClass: "line"
  }, [_c('label', {
    attrs: {
      "for": "HChigh"
    }
  }, [_vm._v("High")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holdCards),
      expression: "holdCards"
    }],
    attrs: {
      "type": "radio",
      "value": "high",
      "id": "HChigh"
    },
    domProps: {
      "checked": _vm._q(_vm.holdCards, "high")
    },
    on: {
      "change": function($event) {
        _vm.holdCards = "high"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "HCmid"
    }
  }, [_vm._v("Medium")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holdCards),
      expression: "holdCards"
    }],
    attrs: {
      "type": "radio",
      "value": "mid",
      "id": "HCmid"
    },
    domProps: {
      "checked": _vm._q(_vm.holdCards, "mid")
    },
    on: {
      "change": function($event) {
        _vm.holdCards = "mid"
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "HClow"
    }
  }, [_vm._v("Low")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.holdCards),
      expression: "holdCards"
    }],
    attrs: {
      "type": "radio",
      "value": "low",
      "id": "HClow"
    },
    domProps: {
      "checked": _vm._q(_vm.holdCards, "low")
    },
    on: {
      "change": function($event) {
        _vm.holdCards = "low"
      }
    }
  })]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.showHoldCards
    }
  }, [_vm._v(_vm._s(_vm.holdCardsShown ? "hide details" : "show details"))]), _c('br'), _vm._v(" "), (_vm.holdCardsShown) ? _c('p', [_vm._v("\n      This describes the maximum number of cards a player can have before they must turn in cards and how many sets of cards a player may turn in at one time.\n      "), _vm._m(0)]) : _c('br')]) : _vm._e(), _vm._v(" "), (_vm.step === 2) ? _c('div', [_c('div', [_c('h4', [_vm._v("Player " + _vm._s(_vm.currentPlayer + 1))]), _vm._v(" "), _c('label', [_vm._v("Human")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBot),
      expression: "isBot"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": false,
      "checked": _vm._q(_vm.isBot, false)
    },
    on: {
      "change": function($event) {
        _vm.isBot = false
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("AI")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isBot),
      expression: "isBot"
    }],
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": true,
      "checked": _vm._q(_vm.isBot, true)
    },
    on: {
      "change": function($event) {
        _vm.isBot = true
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v("Name:")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.players[_vm.currentPlayer].name),
      expression: "players[currentPlayer].name"
    }],
    attrs: {
      "maxlength": "22"
    },
    domProps: {
      "value": (_vm.players[_vm.currentPlayer].name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.players[_vm.currentPlayer], "name", $event.target.value)
      }
    }
  }), _c('br'), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.error))]), _vm._v(" "), (_vm.isBot) ? _c('iconbox', {
    attrs: {
      "double": false,
      "code": _vm.filteredCode,
      "changeIcon": _vm.changeIcon
    }
  }) : _c('iconbox', {
    attrs: {
      "double": true,
      "code": _vm.filteredCode,
      "changeIcon": _vm.changeIcon
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('icon', {
    attrs: {
      "code": _vm.code,
      "size": 40
    }
  })], 1)], 1)]) : _vm._e(), _vm._v(" "), (_vm.step === 3) ? _c('div', [_c('p', [_vm._v("Here are the players, listed in the order they will play in the game. However, depending on how many players there are, initial troop distribution may be in a different order.")]), _vm._v(" "), _c('ol', _vm._l((_vm.shuffledPlayers), function(player) {
    return _c('li', [_c('h4', [_vm._v(_vm._s(player.name) + ":")]), _vm._v(" "), _c('icon', {
      attrs: {
        "code": player.code
      }
    })], 1)
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.step === 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("cancel")]) : _vm._e(), _vm._v(" "), (_vm.step > 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.lastStep
    }
  }, [_vm._v(" << Back")]) : _vm._e(), _vm._v(" "), (_vm.currentPlayer < _vm.numOfPlayers - 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v("Next >>")]) : _vm._e(), _vm._v(" "), (_vm.currentPlayer === _vm.numOfPlayers - 1) ? _c('button', {
    staticClass: "btn",
    on: {
      "click": _vm.nextStep
    }
  }, [_vm._v(_vm._s(_vm.finishText))]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("High: 11 cards max, three sets at a time")]), _vm._v(" "), _c('li', [_vm._v("Medium: 8 cards max, two sets at a time")]), _vm._v(" "), _c('li', [_vm._v("Low: 5 cards max, one set at a time")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-72a2503c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup.vue
// module id = 203
// module chunks = 0